"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _boxModel = _interopRequireDefault(require("./boxModel"));

var expandPadding = (0, _boxModel.default)('padding');
var _default = expandPadding;
exports.default = _default;